import { useCallback } from "react"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_updatePatientSocialHistoryInput,
  chUpdatePatientSocialHistoryMutation,
  chUpdatePatientSocialHistoryMutation$data,
} from "@/modules/patients/services/ch/__generated__/chUpdatePatientSocialHistoryMutation.graphql"
import { chUpdatePatientSocialHistoryMutation as chMutation } from "@/modules/patients/services/ch/chUpdatePatientSocialHistoryMutation"
import {
  De_updatePatientSocialHistoryInput,
  deUpdatePatientSocialHistoryMutation,
  deUpdatePatientSocialHistoryMutation$data,
} from "@/modules/patients/services/de/__generated__/deUpdatePatientSocialHistoryMutation.graphql"
import { deUpdatePatientSocialHistoryMutation as deMutation } from "@/modules/patients/services/de/deUpdatePatientSocialHistoryMutation"

const useUpdatePatientSocialHistoryMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutationWithErrorDialog<
    chUpdatePatientSocialHistoryMutation & deUpdatePatientSocialHistoryMutation
  >(mutation)

  return useCallback(
    (
      input: De_updatePatientSocialHistoryInput & Ch_updatePatientSocialHistoryInput,
      onCompleted?: (
        res: chUpdatePatientSocialHistoryMutation$data & deUpdatePatientSocialHistoryMutation$data,
      ) => void,
      onError?: (res: chUpdatePatientSocialHistoryMutation$data & deUpdatePatientSocialHistoryMutation$data) => void,
    ) => {
      commit({
        variables: {
          input,
        },
        onCompleted(response) {
          const data = response.updatePatientSocialHistory
          if (!data.errors?.length) {
            onCompleted?.(response)
          } else {
            onError?.(response)
          }
        },
      })
    },
    [commit],
  )
}

export { useUpdatePatientSocialHistoryMutation }
